import {Truncate} from "../common/Truncate";

type OnClick = () => void;

interface DLPColumnProps {
    value?: string
    children?: React.ReactNode
    className? : string
    maxLength? : number
    onClick? : OnClick
}

export const DLPColumn = ({value, children, className, maxLength = 80, onClick}: DLPColumnProps) => {
    return (
        <td onClick={onClick} className={`user-select-all ${onClick !== undefined ? "cursor-pointer" : undefined} ${className}`}>{children}<Truncate value={value} maxLength={maxLength}/></td>
    )
}
